<script setup lang="ts">
defineProps<{
  eyebrow: string
  title: string
  intro?: string
}>()
</script>

<template>
  <section class="relative flex flex-col space-y-4">
    <div class="service-meta z-10 flex flex-col items-center px-4 text-center">
      <Heading as="h2" size="caption" class="mb-2">
        {{ eyebrow }}
      </Heading>
      <Heading as="h3" size="large" class="mb-4">
        {{ title }}
      </Heading>
      <Paragraph v-if="intro" size="medium" class="mb-4 max-w-lg">
        {{ intro }}
      </Paragraph>
    </div>

    <div>
      <slot />
    </div>
  </section>
</template>
